
/* injects from baggage-loader */

import FableDialogModule from './fable-dialog/fable-dialog.module';
import InterviewBallonModule from './interview-ballon/interview-ballon.module';
import DroppableBoxModule from './droppable-box/droppable-box.module.js';
import LetterBoxModule from './letter-box/letter-box.module.js';

const shared = angular.module('ui-module', [
	FableDialogModule.name,
	InterviewBallonModule.name,
	LetterBoxModule.name,
	DroppableBoxModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/ui/ui.module.js